import styled from 'styled-components'
import { Row } from 'react-bootstrap'

export const SearchRow = styled(Row)`
  margin: 12px 0 20px 0 !important;
`

export const FilterWrapper = styled.div`
  .input-group {
    height: 28px;
  }
  
  .form-control {
    height: 28px;
    font-size: 0.8rem;
    padding: 0.25rem 0.5rem;
  }
  
  .input-group-text {
    height: 28px;
    padding: 0.25rem 0.5rem;
  }
`